export default __webpack_public_path__ + "static/media/gmail.030b1f86.svg";